import { Link } from "react-router";
import type { RecurringDetail } from "@/lib/recurring/recurring-detail";
import { RecurringDetailView } from "@/components/recurring/recurring-detail-view";
import { useLoaderData, type LoaderFunctionArgs } from "react-router";
import { load } from "../api/load";
import { seg } from "../api/respond";

type Data = RecurringDetail;

export function loader({ params }: LoaderFunctionArgs) {
  return load<Data>(`/api/v1/admin/recurring/${seg(params.id!)}`);
}

export default function RecurringDetailPage() {
  const recurring = useLoaderData() as Data;
  const now = new Date();

  return (
    <div className="flex flex-col gap-6">
      <nav className="flex items-center justify-between">
        <div className="flex items-center gap-2 text-[13px] text-fc-text-secondary">
          <Link to="/admin" className="text-fc-text-dim hover:text-fc-text">
            Home
          </Link>
          <span className="text-fc-text-dim">/</span>
          <Link
            to={`/admin/groups/${recurring.groupId}`}
            className="text-fc-text-dim hover:text-fc-text"
          >
            {recurring.groupName}
          </Link>
          <span className="text-fc-text-dim">/</span>
          <span className="font-medium text-fc-text font-mono">
            r_{recurring.id.slice(0, 8)}
          </span>
        </div>
        <Link
          to={`/admin/groups/${recurring.groupId}`}
          className="inline-flex items-center gap-2 rounded-md border border-fc-border bg-fc-overlay px-3 py-1.5 text-[12.5px] text-fc-text hover:border-fc-brand"
        >
          ← Back to group
        </Link>
      </nav>

      <RecurringDetailView recurring={recurring} now={now} />
    </div>
  );
}
